function validDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
        return false;
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}
/** Callers select authorized/approved requests and convert instants to their calendar first. */
export function resolveWantedAssignments(options) {
    if (!validDate(options.startDayString) ||
        !validDate(options.endDayString) ||
        options.startDayString > options.endDayString)
        throw new Error("INVALID_WANTED_RANGE");
    const nurses = new Set(options.nurseIds), shifts = new Set(options.workShiftIds);
    const rows = new Map();
    for (const assignment of options.assignments) {
        const workShiftId = assignment.workShiftId || options.offShiftId;
        if (!validDate(assignment.date) ||
            !nurses.has(assignment.nurseId) ||
            !workShiftId ||
            !shifts.has(workShiftId) ||
            assignment.date < options.startDayString ||
            assignment.date > options.endDayString)
            continue;
        let days = rows.get(assignment.nurseId);
        if (!days) {
            days = new Map();
            rows.set(assignment.nurseId, days);
        }
        // One cell per nurse/date. Preserve Backoffice's existing last-wins request order.
        days.set(assignment.date, { ...assignment, workShiftId });
    }
    const assignments = Array.from(rows.values()).flatMap((days) => Array.from(days.values()));
    const fixedSchedule = {};
    const owns = Object.prototype.hasOwnProperty;
    for (const { nurseId, date, workShiftId } of assignments) {
        // IDs are opaque: define own properties to handle even prototype-like identifiers safely.
        if (!owns.call(fixedSchedule, date))
            Object.defineProperty(fixedSchedule, date, {
                value: {},
                enumerable: true,
                writable: true,
                configurable: true,
            });
        if (!owns.call(fixedSchedule[date], workShiftId))
            Object.defineProperty(fixedSchedule[date], workShiftId, {
                value: [],
                enumerable: true,
                writable: true,
                configurable: true,
            });
        fixedSchedule[date][workShiftId].push(nurseId);
    }
    return { assignments, fixedSchedule };
}
//# sourceMappingURL=fixed-assignments.js.map